<template>
	<div>
		<div class="menu-item" v-if="!exportFilteredClicked" @click="exportCsv(true)">
			<span>{{ $t("export-excel-filter") }}</span>
		</div>
		<div class="menu-item" v-else v-loading="true">
			<span>{{ $t("export-excel-filter") }}</span>
		</div>

		<div class="menu-item" v-if="!exportAllClicked" @click="exportCsv(false)">
			<span>{{ $t("export-excel") }}</span>
		</div>
		<div class="menu-item" v-else v-loading="true">
			<span>{{ $t("export-excel") }}</span>
		</div>

		<a ref="downloadBtn" :download="$t(this.csvEntity) + '.csv'" :href="csvFileUrl" />
	</div>
</template>

<script>
import axios from "axios"
export default {
	name: "csv-export",
	props: ["csvEntity", "csvHeader", "csvFilters", "processCsv", "csvUrl"],
	data() {
		return {
			csvFileUrl: undefined,
			exportAllClicked: false,
			exportFilteredClicked: false
		}
	},
	methods: {
		exportCsv: function (withFilters) {
			if (withFilters) this.exportFilteredClicked = true
			else this.exportAllClicked = true

			let csv = []
			csv.push(this.csvHeader.join(","))

			var filters = this.csvFilters(withFilters)
			var url = this.csvUrl ? this.csvUrl : process.env.VUE_APP_API_URL + "/api/" + this.csvEntity + "/filters"

			axios
				.post(url, filters, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					let aaa = res.data.array ? res.data.array : res.data.items

					aaa.forEach(item => {
						let data = this.processCsv(item)
						csv.push(data.join(","))
					})

					csv = csv.join("\n")

					var csvFile = new Blob([csv], { type: "text/csv" })
					this.csvFileUrl = window.URL.createObjectURL(csvFile)

					//necessario timeout altrimenti l'attributo download non è stato ancora settato
					setTimeout(
						function (context, withFilters) {
							context.$refs.downloadBtn.click()

							if (withFilters) context.exportFilteredClicked = false
							else context.exportAllClicked = false
						},
						1000,
						this,
						withFilters
					)
				})
				.catch(err => console.error(err))
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-menu";
</style>
